import {
  Component, ChangeDetectionStrategy, ChangeDetectorRef
} from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
  ActionSheetController,
  ToastController,
  Platform,
  ModalController
} from "ionic-angular";

import { SurveyPage } from "../survey/survey";
import { HomePage } from "../home/home";
import { PatientsPage } from "../patients/patients";

import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import * as _ from "lodash";
import { InAppBrowser } from "@ionic-native/in-app-browser";

@IonicPage()
@Component({
  selector: "page-patient-medication",
  templateUrl: "patient-medication.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PatientMedicationPage {
  patient: any;
  order: any = {};
  orderinprocess = true;
  prescription;
  lastImage: string;
  public error: string;
  prescriptionmedcount: number = 0;
  prescriptionstudy: any = [];
  uploadComplete: boolean = false;
  doctor: any;
  previousdoctor: any;
  testImage: any;
  existingpatient: boolean = false;
  ismobile: boolean = false;
  public doctorList: Observable<any[]>;
  public medicationPrescriptionList: Observable<any>;
  public medicationOTCList: Observable<any>;
  public clinic: any;
  public studyDocument: any;
  public studyResult: any = {};
  clinic_name: string;
  clinic_id: string;
  previouscategory: string;
  medtype: string = 'prescription';
  doctor_id: string = null;
  prescription_id: string = null;
  study_previously_completed = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public alertController: AlertController,
    public actionSheetCtrl: ActionSheetController,
    public toastCtrl: ToastController,
    public plt: Platform,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public modalCtrl: ModalController,
    private cd: ChangeDetectorRef,
    private iab: InAppBrowser
  ) {
    this.patient = this.navParams.data["patient"];
    this.doctor = this.navParams.data["doctor"];
    this.previousdoctor  = this.navParams.data["doctor"];
    if(this.previousdoctor) this.doctor_id = this.previousdoctor.last_name;
    else this.doctor_id = null;
    this.existingpatient = this.navParams.data["existingpatient"];
    this.prescription_id = this.navParams.data['prescription_id'];
    console.log("Prescription ID: ", this.prescription_id);

    this.order["patient"] = this.patient;
    this.order["medication"] = [];

    if(this.previousdoctor) this.order["doctor"] = this.previousdoctor;
    else this.order["doctor"] = null;
    this.order["studies"] = [];
    this.order["prescription_image"] = null;

    if (plt.is("ios") || plt.is("android")) {
      this.ismobile = true;
    }

    console.log("Has done study?", this.patient.study);

    this.auth.getCurrentUser().then(user => {

      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.database.getClinic(this.clinic_id).valueChanges().subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
        }
               
        console.log("Study Override: ", this.clinic.regatta_override);
        this.medicationPrescriptionList = this.database.getMedicationsPrescriptionByClinic(this.clinic_id, this.clinic.regatta_override);
        this.medicationOTCList = this.database.getMedicationsOTCByClinic(this.clinic_id).valueChanges();
        this.cd.markForCheck();
      });

      this.doctorList = this.database
        .getDoctorsByClinic(this.clinic_id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        });
      this.cd.markForCheck();
    });

  }

  ionViewDidLoad() {}

  doc(doctor) {
    this.order.doctor = doctor;
    this.cd.markForCheck();
  }

  onPrescriptionUrlEmitted(file) {
    this.order.prescription_image = file;
    this.cd.markForCheck();
  }

  med(medication) {
  
    if(this.order.medication.findIndex(x => x.din === medication.din) > -1) {
      _.remove(this.order.medication, medication);
      this.prescriptionmedcount = this.order.medication.filter(
        item => item.type === "Prescription"
      ).length;
      console.log("Removing Med From Order: ", this.order.medication)

      if(medication.studies)  {
      const studyArray = medication.studies[0];
      console.log("Found study: ", studyArray)
      if(studyArray) {
        const studyIdx = this.order.studies.findIndex(x => x.name === medication.studies[0].name);
        const studyExists = (studyIdx > -1)
        console.log("Is Study? ", studyExists)
        console.log("Study Idx ", studyIdx)
        console.log("Study Count: ", this.order.studies[studyIdx]['count'])
        if(studyIdx > -1 && this.order.studies[studyIdx]['count'] > 1) { 
          this.order.studies[studyIdx]['count'] -= 1;
        }
        else {
          this.order.studies = [];
        }
      }
      }
    }
    else {
      this.order.medication.push(medication);
      this.prescriptionmedcount = this.order.medication.filter(
        item => item.type === "Prescription"
      ).length;
      console.log("Adding Med To Order: ", this.order.medication)

      if(medication.studies)  {
      const studyArray = medication.studies[0];
      console.log("Found study: ", studyArray)
      if(studyArray) {
        const studyIdx = this.order.studies.findIndex(x => x.name === medication.studies[0].name);
        const studyExists = (studyIdx > -1)
        console.log("Is Study? ", studyExists)
        console.log("Study Idx ", studyIdx)
        if((this.patient.study.completed) && (this.patient.study.name === studyArray.name)) {
          studyArray.isComplete = true;
          studyArray.completeDate = this.patient.study.updatedAt;
          
        }

        if(studyExists) { 
          this.order.studies[studyIdx]['count'] += 1;
        }
        else {
          studyArray['count'] = 1;
          this.order.studies.push(studyArray);
        }
      }
    }
    }    
  }

  doStudy(study)  {

    let studydata = {
      clinic: this.clinic,
      patient: this.patient,
      doctor: this.order.doctor,
      medication: this.order.medication,
      study: this.order.studies,
      renewal: false
    };

    let studyModal = this.modalCtrl.create(SurveyPage, studydata, {cssClass: 'select-modal', enableBackdropDismiss: false });
    studyModal.onDidDismiss(data => {
      console.log(data)
      if(data['completed'])  {
        study.isComplete = true;
        study.consent_agreement = data['consent_agreement'];
        this.studyResult['_status'] = 'enrolled';
      }
      else {
        study.isComplete = false;
        study.consent_agreement = null;
        this.studyResult['_status'] = 'notenrolled';
      }
      this.studyResult = data;
      this.cd.markForCheck();
    });
    studyModal.present();
  }

  cancelOrder(): void {
    let confirm = this.alertController.create({
      title: "Cancel Order",
      message: "Are you sure you would like to cancel this order?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't cancel order");
          }
        },
        {
          text: "Yes",
          handler: () => {
            if (this.existingpatient) {
              this.navCtrl.pop();
            } else {
              this.navCtrl.setRoot(PatientsPage);
            }
          }
        }
      ]
    });
    confirm.present();
  }

  reviewOrder() {
    let study_previously_completed = false;
    _.forEach(this.order.medication, (med) => {
      if(med.studies.length > 0)  {
        if(med.studies[0].name === this.patient.study.name) {
          console.log(med.studies[0].name + ' has been already completed');
          study_previously_completed = true;
        }
      }
    });
      
    if(!study_previously_completed) {
        if(!this.studyResult['clinic_id']) {
          this.studyResult['study_id_last'] = null
          this.studyResult['clinic_id'] = this.clinic_id;
          this.studyResult['clinic_name'] = this.clinic_name;
          this.studyResult['doctor_id'] = this.order.doctor.id;
          this.studyResult['patient_id'] = this.patient.id
          this.studyResult['Renewed'] = false;
          this.studyResult['speedscore'] = null
          this.studyResult['agreement'] = {
            'signatory_name': null,
            'signature': null,
            'consent_name': null,
            'consent_signature': null
          }
          this.studyResult['doctor'] = this.order.doctor;
          this.studyResult['patient'] = this.order.patient;
          this.studyResult['study'] = this.order.studies
          this.studyResult['completed'] = false;
          this.studyResult['_status'] = 'notenrolled';
          console.log("Empty Study Result: ", this.studyResult)
        }
    }
    console.log("Order: ", this.order)
    console.log("Study Result: ", this.studyResult);
      let canSave: boolean = true;
      let errorMsg: string = null;

      console.log("Reviewing Doctors Selection: ", this.order.doctor);
      if (!this.order.doctor) {
        canSave = false;
        errorMsg = "You must select a doctor before proceeding.";
      } else if (this.order.medication.length === 0) {
        canSave = false;
        errorMsg = "You must select a medication before proceeding.";
      } else if (this.prescriptionmedcount > 0 && this.order.prescription_image === null) {
        canSave = false;
        errorMsg = "You have selected a medication that requires a prescription but haven't uploaded or taken a picture of that prescription.";
      }

      if (!canSave) {
        let alert = this.alertController.create({
          title: "Order Issue",
          subTitle: errorMsg,
          buttons: ["OK"]
        });
        alert.present();
      } else {
        let ordermessage: string =
          "Please review your final order before submitting.<br/><br/>" +
          "Order for " +
          this.patient.first_name +
          " " +
          this.patient.last_name +
          "<br/><br/>" +
          "<strong>Doctor</strong><br/>Dr. " +
          this.order.doctor.last_name +
          "<br/><br/>" +
          "<strong>Medications</strong><br/>";
        for (let med of this.order.medication) {
          ordermessage += med.name + "<br/>";
        }

        let confirm = this.alertController.create({
          title: "Review Order",
          message: ordermessage,
          buttons: [
            {
              text: "Cancel",
              handler: () => {
                console.log("Don't save order right now");
              }
            },
            {
              text: "Place Order",
              handler: () => {
                this.database.savePrescription(this.clinic_id, this.clinic_name, this.patient.id, this.order, this.prescription_id, this.studyResult)
                .then(() => {
                  this.orderinprocess = false;
                  this.cd.markForCheck();
                })
                .catch((err) => {
                  this.orderinprocess = true;
                  console.log("Problem with saving prescriptions")
                  this.cd.markForCheck();
                });
              }
            }
          ]
        });
        confirm.present();
      }
  }

  viewConsent(url)  {
    this.iab.create(url);
  }

  goHome() {
    this.navCtrl.setRoot(HomePage);
  }

  isDivider(category) {
    if(!category) return false;
    if(category !== this.previouscategory)  {
      this.previouscategory = category;
      return true;
    }
    else {
      this.previouscategory = category;
      return false;
    }
  }

  /*
  private handleError(error: any) {
    const errMsg = error.message ? error.message : error.toString();
    this.error = errMsg;
    this.uploadComplete = false;
    return Observable.throw(errMsg);
  }
  */
}



// WEBPACK FOOTER //
// ./src/pages/patient-medication/patient-medication.ts